import cn from 'classnames'

import style from '@src/pages/BlockService/BlockService.module.scss'
import { IndividualsPanel } from '@src/components/IndividualsPanel/IndividualsPanel'
import { Footer } from '@src/components/Footer/Footer'
import { FreeBlocking } from '@src/pages/BlockService/FreeBlocking'
import { ReturnBtn } from '@src/components/Button/ReturnBtn'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '@src/store/store'
import { useEffect } from 'react'
import { setPageTitle } from '@src/store/ducks/app/reducer'

export const BlockService = () => {
  const dispatch = useDispatch<AppDispatch>()

  useEffect(() => { dispatch(setPageTitle('Временная блокировка – установка добровольной блокировки')) }, [dispatch])

  return (
    <div>
      <IndividualsPanel />
      <div className={cn(style.tariffContainer, 'container')}>
        <ReturnBtn type="secondary">Вернуться</ReturnBtn>
        <h2 className={style.mainTitle}>Блокировка услуги</h2>
        <div className={style.blockService}>
          <FreeBlocking />
        </div>
      </div>
      <Footer />
    </div>
  )
}
